import { ViewBooking } from "collins-js-sdk";
import { BookingV4 } from "../../../../../types/bookings";
import { TabIconTypes } from "../../../../Shared/Tabs/Tab/TabIcon";

export enum SelectedBookingTabEnum {
  Manage = "Manage",
  Guests = "Guests",
  PreOrders = "Pre-Orders",
  Payments = "Payments",
  Notes = "Notes",
  Messages = "Messages",
  Documents = "Documents",
  Linked = "Linked",
  History = "History"
}

export type TabListType = {
  key: SelectedBookingTabEnum;
  icon: TabIconTypes;
  size?: "sm" | "md" | "lg";
  title: string;
  count: number;
  badgeCount: number;
  isEnabled: boolean;
};

export const getTabList = (
  selectedBookingV4: BookingV4 | undefined,
  selectedBooking: ViewBooking | undefined,
  isPaymentsEnabled: boolean = true,
  isPreOrdersEnabled: boolean = true,
  isDocumentsEnabled: boolean = true
): TabListType[] => {
  const current =
    selectedBooking &&
    selectedBookingV4 &&
    selectedBooking?.id === selectedBookingV4?._id;

  const manageTab: TabListType = {
    key: SelectedBookingTabEnum.Manage,
    icon: "manage",
    title: SelectedBookingTabEnum.Manage,
    count: 0,
    badgeCount: 0,
    isEnabled: true
  };

  const guestTabCount = selectedBookingV4?.group_members?.length ?? 0;
  const guestTab: TabListType = {
    key: SelectedBookingTabEnum.Guests,
    icon: "guests",
    title: SelectedBookingTabEnum.Guests,
    count: current ? guestTabCount : 0,
    badgeCount: 0,
    isEnabled: true
  };

  const preOrdersTabCount =
    selectedBookingV4?.preorders?.filter(
      (preOrder) => !preOrder.status || preOrder.status !== "deleted"
    )?.length ?? 0;
  const preOrdersTab: TabListType = {
    key: SelectedBookingTabEnum.PreOrders,
    icon: "preorders",
    title: SelectedBookingTabEnum.PreOrders,
    count: current ? preOrdersTabCount : 0,
    badgeCount: 0,
    isEnabled: isPreOrdersEnabled
  };

  const paymentsTabCount = selectedBookingV4?.deposits?.length ?? 0;
  const paymentsTab: TabListType = {
    key: SelectedBookingTabEnum.Payments,
    icon: "payments",
    title: SelectedBookingTabEnum.Payments,
    count: current ? paymentsTabCount : 0,
    badgeCount: 0,
    isEnabled: isPaymentsEnabled
  };

  const notesTabCount =
    (selectedBookingV4?.comments?.length ?? 0) +
    (selectedBookingV4?.admin_notes?.length ?? 0);
  const notesTab: TabListType = {
    key: SelectedBookingTabEnum.Notes,
    icon: "notes",
    title: SelectedBookingTabEnum.Notes,
    count: current ? notesTabCount : 0,
    badgeCount: 0,
    isEnabled: true
  };

  const documentsTabCount = selectedBookingV4?.documents?.length ?? 0;
  const documentsTab: TabListType = {
    key: SelectedBookingTabEnum.Documents,
    icon: "documents",
    title: SelectedBookingTabEnum.Documents,
    count: current ? documentsTabCount : 0,
    badgeCount: 0,
    isEnabled: isDocumentsEnabled
  };

  const receivedMessages = selectedBookingV4?.notifications?.filter(
    (notification) => notification.type === "message_received"
  );
  const messagesTabCount = receivedMessages?.length ?? 0;
  const messagesTabNew =
    receivedMessages?.filter(
      (notification) =>
        notification.status === "new" &&
        notification.type === "message_received"
    ).length ?? 0;
  const messagesTab: TabListType = {
    key: SelectedBookingTabEnum.Messages,
    icon: "messages",
    title: SelectedBookingTabEnum.Messages,
    count: current ? messagesTabCount : 0,
    badgeCount: current ? messagesTabNew : 0,
    isEnabled: true
  };

  const linkedTabCount = selectedBooking?.linkedBookings?.length ?? 0;
  const linkedTab: TabListType = {
    key: SelectedBookingTabEnum.Linked,
    icon: "linked",
    title: SelectedBookingTabEnum.Linked,
    count: current ? linkedTabCount : 0,
    badgeCount: 0,
    isEnabled: true
  };
  const historyTab: TabListType = {
    key: SelectedBookingTabEnum.History,
    icon: "history",
    title: SelectedBookingTabEnum.History,
    count: 0,
    badgeCount: 0,
    isEnabled: true
  };

  return [
    manageTab,
    guestTab,
    preOrdersTab,
    paymentsTab,
    notesTab,
    documentsTab,
    messagesTab,
    linkedTab,
    historyTab
  ];
};
